module.exports = __webpack_public_path__ + "static/media/meeting.40241ee0.svg";